/* eslint-disable react/style-prop-object */
import { useContext, useEffect, useState } from "react";
import SecondHeader from "../Header/SecondHeader";
import DriversHead from "./DriversParts/DriversHead";
import { popupcontext } from "../../context/Popupscontext";
import { Helmet } from "react-helmet";
import { useGetAllDriversQuery } from "../../Redux/service/Drivers/Drivers";
import { filtrationcontext } from "../../context/Filtercontext";
import Loader from "../Helpers/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { addDrivers } from "../../Redux/service/Drivers/DriversSlice";
import { DriverForm } from "./DriversForm/DriverForm";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import trans, { isRTL } from "../../utils";
import AntdTable from "../antd/Table/Table";
import Actions from "../antd/Table/Actions";
import usePermission from "../../hooks/usePermission";
export default function Drivers() {
	let { handleShow, setEdited, deleteItem, setDeleteItem } =
		useContext(popupcontext);
	const {
		limit,
		setLimit,
		Sort,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	let { pathname } = useLocation();
	let getShortPath = () => pathname.split("/").pop();
	let driverApi = getShortPath() === "drivers";

	const [currentPage, setCurrentPage] = useState(1);
	const [sort, setSort] = useState({
		by: "id",
		order: "desc",
	});
	const [loading, setLoading] = useState(false);
	const { create, edit, delete: canDelete } = usePermission("FMSDRIVERS");

	localStorage.setItem("page", currentPage);
	const dispatch = useDispatch();
	let {
		data: DriverData,
		isLoading,
		isError,
		refetch,
		error,
	} = useGetAllDriversQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
		},
		{
			skip: !currentPage || !limit || !sort.by || !sort.order || !driverApi,
		},
	);

	useEffect(() => {
		return () => {
			SetSortFilter({ type: "id", value: null });
			setLimit(10);
			localStorage.setItem("page", 1);
			setSearchQuery("");
		};
	}, [setLimit, SetSortFilter, setSearchQuery]);
	useEffect(() => {
		if (DriverData) {
			dispatch(addDrivers(DriverData.drivers));
			if (DriverData?.drivers.length === 0 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
			}
		}
		setLoading(false);
	}, [DriverData, currentPage, dispatch]);

	useEffect(() => {
		if (deleteItem?.condition === true && deleteItem?.value === "drivers") {
			refetch();
			if (DriverData?.drivers.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			dispatch(addDrivers(DriverData?.drivers));
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		dispatch,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		DriverData?.drivers,
	]);

	useEffect(() => {
		if (deleteItem?.condition === true && deleteItem?.value === "drivers") {
			refetch();
			if (DriverData?.drivers.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			dispatch(addDrivers(DriverData?.drivers));
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		dispatch,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		DriverData?.drivers,
	]);

	const handleSuccess = async (newDriver) => {
		if (DriverData) {
			setLoading(true);
			//const updatedDrivers = [newDriver, ...DriverData.drivers].slice(0, 5);
			refetch();
		}
	};
	const handleEdit = async (updatedDriver) => {
		if (DriverData) {
			dispatch(
				addDrivers(
					DriverData.drivers.map((driver) =>
						driver?.id === updatedDriver?.id ? updatedDriver : driver,
					),
				),
			);
			setEdited(true);
			refetch();
		}
	};
	const handlePageClick = async (data) => {
		const selectedPage = data.selected + 1;
		setCurrentPage(selectedPage);
	};
	const inf = useSelector((state) => state.users.user);
	if (isError)
		return toast.error(trans(error?.data?.message || "Please try again"), {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});

	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "id",
				order: "desc",
			});
		}
	};

	const driversColumns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			width: 150,
			sorter: true,
			fixed: !isRTL ? "left" : undefined,
			render: (name) => (
				<span className={"table-element-name ps-0"}>{name}</span>
			),
		},
		{
			title: trans("driver code"),
			dataIndex: "code",
			fixed: !isRTL ? "left" : undefined,
			sorter: true,
			width: 150,
		},
		{
			title: trans("ID number"),
			dataIndex: "idNo",
			width: 150,
			sorter: true,
			render: (idNo) => idNo || "N/A",
		},
		{
			title: trans("phone number"),
			dataIndex: "phoneNumber",
			sorter: true,
			width: 150,
			render: (phoneNumber) => phoneNumber || "N/A",
		},
		{
			title: trans("Address"),
			dataIndex: "address",
			sorter: true,
			width: 150,
			render: (address) => address || "N/A",
		},
		{
			title: trans("Actions"),
			width: 150,
			fixed: !isRTL ? "right" : undefined,
			render: ({ id, name }) => (
				<Actions
					DriverId={id}
					canAddTask={create}
					canDelete={canDelete}
					canEdit={edit}
				/>
			),
		},
	];

	return (
		<>
			<Helmet>
				<title>Drivers</title>
				<meta name="description" content="Drivers" />
			</Helmet>
			{(inf.administrator === true ||
				inf.deviceReadonly === true ||
				(inf.administrator === false &&
					(inf.deviceLimit > 0 || inf.deviceLimit === -1))) && (
				<>
					<SecondHeader
						title={trans("drivers")}
						add={create ? trans("Add new driver") : null}
						onClick={() => handleShow("addForm")}
					/>
				</>
			)}

			<DriversHead />
			{isLoading || loading ? (
				<div className="loader-container loader-table">
					<Loader />
				</div>
			) : (
				<>
					<div className="bg-white-rounded-top table-parent">
						<AntdTable
							columns={driversColumns}
							dataSource={DriverData?.drivers || []}
							loading={isLoading || loading}
							pageSize={limit}
							totalItems={DriverData?.totalCount}
							currentPage={currentPage}
							onPageChange={(page) => setCurrentPage(page)}
							onLimitChange={(newLimit) => {
								setLimit(newLimit);
								setCurrentPage(1);
							}}
							onTableChange={handleTableChange}
						/>
					</div>
				</>
			)}
			<DriverForm onSuccess={handleSuccess} onEdit={handleEdit} />
		</>
	);
}
